import { createApi } from '@reduxjs/toolkit/query/react';
import { listFinancialYearTransferHistory } from '../../graphql';
import { baseQuery } from '../baseQuery';



export const listFYTransferHistoryApi = createApi({
    reducerPath: 'listFYTransferHistory',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        listFYTransferHistory: builder.query({
            query: () => ({ body: listFinancialYearTransferHistory }),
            keepUnusedDataFor: 300,
            refetchOnMountOrArgChange: true,
            providesTags: ['listFYTransferHistory'],
        }),
    }),
});

export const { useListFYTransferHistoryQuery } = listFYTransferHistoryApi;